import { useQuery } from '@tanstack/react-query'

import { getMomentImagesPayloadByMomentId } from '@/local-db/moment-images'

import { queries } from '../../query-keys'

const useLocalImagesByMomentId = (momentId: string) => {
  return useQuery({
    queryKey: queries.localImagesByMomentId(momentId).queryKey,
    queryFn: () => getMomentImagesPayloadByMomentId(momentId),
  })
}

export default useLocalImagesByMomentId
